/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalendarBlockDto } from '../models/CalendarBlockDto';
import type { CompactCalendarBlockDto } from '../models/CompactCalendarBlockDto';
import type { CreateCalendarBlockDto } from '../models/CreateCalendarBlockDto';
import type { DeleteSingleCalendarBlockDto } from '../models/DeleteSingleCalendarBlockDto';
import type { GetCompactCalendarBlocksRequestDto } from '../models/GetCompactCalendarBlocksRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarBlockControllerService {
    /**
     * @param requestBody
     * @returns CalendarBlockDto Created
     * @throws ApiError
     */
    public static createCalendarBlocks(
        requestBody: CreateCalendarBlockDto,
    ): CancelablePromise<Array<CalendarBlockDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/calendar-blocks',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns CompactCalendarBlockDto OK
     * @throws ApiError
     */
    public static getCompactCalendarBlocksBySchedule(
        requestBody: GetCompactCalendarBlocksRequestDto,
    ): CancelablePromise<Array<CompactCalendarBlockDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/calendar-blocks/by-schedule',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteCalendarContigousBlock(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/calendar-blocks/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static deleteSingleCalendarBlock(
        requestBody: DeleteSingleCalendarBlockDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/calendar-blocks/single',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param teamId
     * @param startDate
     * @param endDate
     * @returns CalendarBlockDto OK
     * @throws ApiError
     */
    public static getManualCalendarBlocks(
        teamId: number,
        startDate: string,
        endDate: string,
    ): CancelablePromise<Array<CalendarBlockDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/calendar-blocks/manual',
            query: {
                'teamId': teamId,
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
}
